import { Box } from '../Box';
import type { BoxProps } from '../Box';

type VisuallyHiddenProps = BoxProps & {
  /**
   * Pass true to skip the wrapper and just return the content
   */
  visible?: boolean;
};

/**
 * Utility compoinent that visually hides its children while still rendering
 * them to the DOM so screen readers can access them.
 * Cf. https://github.com/tamagui/tamagui/blob/master/packages/visually-hidden/src/VisuallyHidden.tsx
 */
export const VisuallyHidden = ({ children, visible, ...props }: VisuallyHiddenProps) => {
  return visible ? (
    children
  ) : (
    <Box
      position="absolute"
      width={1}
      height={1}
      margin={-1}
      zIndex={-10000}
      overflow="hidden"
      opacity={0.00000001}
      pointerEvents="none"
      {...props}
    >
      {children}
    </Box>
  );
};
